import { render, staticRenderFns } from "./AlbumGuideZone.vue?vue&type=template&id=aee9d4b2&scoped=true&"
import script from "./AlbumGuideZone.vue?vue&type=script&lang=js&"
export * from "./AlbumGuideZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumGuideZone.vue?vue&type=style&index=0&id=aee9d4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee9d4b2",
  null
  
)

export default component.exports